// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Access Requests Component - Using Standard Flowchest Dashboard Styles */
/* Status badge styling */
.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-approved {
  background: #d4edda;
  color: #155724;
}

.status-rejected {
  background: #f8d7da;
  color: #721c24;
}

/* Flowchest button styling */
.btn {
  font-family: "Raleway" !important;
  font-weight: 500 !important;
  border-radius: 5px !important;
  transition: all 0.3s ease !important;
  cursor: pointer !important;
  text-transform: none !important;
}

.btn-primary {
  background-color: #5ea1d8 !important;
  color: #fff !important;
  border: none !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
}

.btn-primary:hover {
  background-color: #4a8bc4 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;
}

.btn-warn {
  background-color: #f44336 !important;
  color: #fff !important;
  border: none !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
}

.btn-warn:hover {
  background-color: #d32f2f !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(244, 67, 54, 0.3) !important;
}

.btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Custom select styling to match Flowchest design */
.status-filter {
  background: transparent;
  border: none;
  color: #5ea1d8;
  font-family: "Raleway";
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
}
.status-filter:focus {
  outline: none;
}

/* Ensure consistent Flowchest typography */
h1,
h2,
h3,
h4,
h5,
h6,
p,
span,
div,
td,
th {
  font-family: "Raleway", Arial, Helvetica, sans-serif !important;
}

/* Table styling to match Flowchest design */
.responsive-tabel {
  font-family: "Raleway", Arial, Helvetica, sans-serif !important;
}
.responsive-tabel th,
.responsive-tabel td {
  font-family: "Raleway", Arial, Helvetica, sans-serif !important;
  font-size: 14px !important;
}
.responsive-tabel th {
  font-weight: 600 !important;
  color: #333 !important;
  background-color: #f5f5f5 !important;
  text-transform: uppercase !important;
  font-size: 12px !important;
  letter-spacing: 0.5px !important;
  padding: 16px !important;
  border-bottom: 2px solid #e0e0e0 !important;
}
.responsive-tabel td {
  font-weight: 400 !important;
  color: #666 !important;
}

/* Mobile tile styling to match Flowchest design */
.mobile-design .tile {
  font-family: "Raleway", Arial, Helvetica, sans-serif !important;
}
.mobile-design .tile h3,
.mobile-design .tile p,
.mobile-design .tile span {
  font-family: "Raleway", Arial, Helvetica, sans-serif !important;
}
.mobile-design .tile .bold {
  font-weight: 600 !important;
}

/* Ensure proper spacing for mobile view */
@media (max-width: 768px) {
  .mobile-design {
    display: block;
  }
  .table-parent {
    display: none;
  }
}
@media (min-width: 769px) {
  .mobile-design {
    display: none;
  }
  .table-parent {
    display: block;
  }
}
/* Box grid layout (desktop) */
.request-box-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  margin: 16px 0;
}

@media (max-width: 992px) {
  .request-box-grid {
    display: none;
  }
}
/* Make followers-tag cards look exactly like dashboard cards */
.com-record {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
  border: none !important;
}
.com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}

.com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
}

.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
}

.box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: none !important;
  background-color: #fff !important;
}

.followers-tag .box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
  gap: 12px;
}

.followers-tag .box .icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ico-box {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  padding-right: 10px;
}

.followers-tag .box .ico-box {
  width: 40px;
  height: 40px;
  background: transparent; /* remove bg */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
}

.followers-tag .box .card-icon {
  font-size: 20px;
  color: #5ea1d8;
}

.followers-tag .box .text {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
  justify-content: center;
  gap: 2px;
}

.followers-tag .box .text .count {
  background: white !important;
  box-shadow: none !important;
  display: flex;
  align-items: center;
}

.followers-tag .box .text .count b {
  font-size: 24px; /* increased to match dashboard */
  font-weight: 700 !important; /* bold like dashboard */
  color: #333;
  display: block;
  line-height: 1.2;
}

.followers-tag .box .text p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.2;
  display: block;
}

/* Responsive: match dashboard behavior */
@media (max-width: 767px) {
  .followers-tag {
    gap: 12px;
  }
  .followers-tag .box {
    width: 100%;
    margin: 6px 0;
    min-width: auto;
    border-radius: 8px;
  }
  .followers-tag .box .ico-box {
    width: 36px;
    height: 36px;
  }
  .followers-tag .box .text .count b {
    font-size: 20px !important;
  }
  .followers-tag .box .text p {
    font-size: 13px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .followers-tag .box {
    flex: 1 1 calc(50% - 12px);
    min-width: calc(50% - 12px);
  }
}
/* Mobile tile title icon */
.mobile-design .tile .main-title {
  display: flex;
  align-items: center;
}

.mobile-design .tile .main-title .title-icon {
  font-size: 18px;
  margin-right: 6px;
  color: #fff;
}

.btn-primary {
  background-color: #5ea1d8;
  border: none;
}

/* styles.css */
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  padding: 16px;
  border-bottom: 2px solid #e0e0e0;
}

td {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}

tr:hover {
  background-color: #f9f9f9;
}

.generate-btn {
  padding: 10px 20px 10px 10px;
  text-align: right;
}

.table-parent {
  overflow-x: auto;
}

body {
  overflow-x: hidden;
}

.dashbored-wrap {
  width: 100%;
  height: 100vh;
  background: var(--fc-bg, #fff);
}
.dashbored-wrap .logo {
  width: 100px;
  margin-right: 100px;
}
.dashbored-wrap .top-menu-wrap {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}
.dashbored-wrap .user-name {
  display: flex;
  align-items: center;
}
.dashbored-wrap .user-details {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.dashbored-wrap .user-name p {
  display: flex;
  align-items: center;
}
.dashbored-wrap .user-name span {
  width: 40px;
  height: 40px;
  background: red;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}
.dashbored-wrap .top-menu-wrap {
  width: 100%;
  height: 100px;
  background: #fff;
}
.dashbored-wrap .dash-details {
  width: 100%;
  display: flex;
  max-height: 100vh;
  /* background: green; */
}
.dashbored-wrap .detail-list {
  max-width: 250px;
  width: 100%;
  padding: 20px 10px;
  background-color: #efeeee;
  color: #212529;
  position: fixed;
  top: calc(var(--app-header) + 24px);
  height: calc(100vh - 120px);
}
.dashbored-wrap ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.dashbored-wrap p {
  margin-bottom: 10px;
}
.dashbored-wrap ul li {
  margin-bottom: 10px;
  height: 40px;
  padding: 0px 10px;
  position: relative;
  z-index: 1;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
}
.dashbored-wrap ul li:before {
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0%;
  z-index: -1;
}
.dashbored-wrap ul li:hover {
  color: #000;
}
.dashbored-wrap ul li:hover:before {
  /* background: #fff;
  color: #212529; */
  width: 100%;
}
.dashbored-wrap .table-bordered {
  border: 0px;
}
.dashbored-wrap .detail-description {
  width: 100%;
  height: 100%;
  padding: 0px;
  position: absolute;
  /* background: purple; */
}
.dashbored-wrap .followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
}
.dashbored-wrap h3 {
  position: relative;
  z-index: 3;
  color: #fff;
  font-weight: normal;
}
.dashbored-wrap .com-record {
  width: calc(100% - 250px);
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
}
.dashbored-wrap .com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}
.dashbored-wrap .com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  /* background: gray; */
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
  background: #5ea1d8;
}
.dashbored-wrap .ico-box {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashbored-wrap .table-wrap {
  padding: 30px 30px 30px 0px;
  position: absolute;
  top: 150px;
  width: calc(100% - 30px);
  width: 100%;
  left: 0px;
  /* width:calc(100% - 76px); */
}
.dashbored-wrap .box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
}
.dashbored-wrap .filter-ico li {
  width: 105px;
}
.dashbored-wrap .filter-ico li i {
  color: #000;
}
.dashbored-wrap .text {
  padding-right: 10px;
}
.dashbored-wrap .table-parent {
  overflow-x: auto;
  margin-top: -8px;
  overflow-y: auto;
}
.dashbored-wrap table {
  margin-bottom: 20px;
  border-left: 0px;
  border-bottom: 0px;
  border: 0px;
  overflow-y: auto;
  width: 100%;
}
.dashbored-wrap th,
.dashbored-wrap td {
  border: none;
  color: #333;
  padding: 16px;
  min-width: 100px;
  font-family: "Raleway";
  vertical-align: middle;
}
.dashbored-wrap th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  padding: 16px;
  border-bottom: 2px solid #e0e0e0;
}
.dashbored-wrap td {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}
.dashbored-wrap td[scope=row] {
  position: relative;
}
.dashbored-wrap .inner {
  width: 100%;
  margin-bottom: 0px;
}
.dashbored-wrap .inner td {
  padding: 5px;
  border: 0px;
}
.dashbored-wrap .inner td:first-child {
  width: 30px;
}
.dashbored-wrap tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
.dashbored-wrap tbody tr:hover {
  background-color: #f9f9f9;
}
.dashbored-wrap tbody tr:hover td {
  color: #333;
}
.dashbored-wrap tbody tr:last-child td {
  border-bottom: none;
}
.dashbored-wrap tbody tr span {
  display: flex;
  align-items: center;
}
.dashbored-wrap .filter {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  border: none;
  padding: 0 0 16px;
}
.dashbored-wrap .filter-title {
  flex: 1;
}
.dashbored-wrap .filter ul {
  display: flex;
  float: right;
}
.dashbored-wrap .filter-bar {
  display: flex;
  width: 100%;
  gap: 16px;
  align-items: center;
}
.dashbored-wrap .filter-bar .input {
  flex: 0 0 auto;
}
.dashbored-wrap .filter-ico {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}
.dashbored-wrap .search-container {
  position: relative;
  width: 400px;
  max-width: 100%;
}
.dashbored-wrap .search-container ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.dashbored-wrap .chekbox-image {
  display: flex;
}
.dashbored-wrap .chekbox-image td:first-child {
  width: unset;
  flex: 1;
  min-width: 150px;
  display: flex;
  align-items: flex-start;
}
.dashbored-wrap .chekbox-image td:first-child span {
  padding-left: 13px;
}
.dashbored-wrap .chekbox-image td:last-child {
  min-width: unset;
  width: 40px;
  display: flex;
  align-items: flex-start;
}
.dashbored-wrap .image-sec img {
  max-width: 100%;
  max-height: 80px;
  object-fit: cover;
}
.dashbored-wrap .mobile-design {
  display: none;
}

/* Flow Reviews–style filters/search bar */
.filters-section {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: nowrap;
  align-items: center;
  overflow: visible;
}
.filters-section .search-filter {
  flex: 1 1 640px;
  min-width: 320px;
  max-width: 720px;
}
.filters-section .search-filter .search-field {
  width: 100%;
}
.filters-section .search-filter .search-field ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.filters-section .search-filter .search-field ::ng-deep .mat-mdc-text-field-wrapper {
  width: 100%;
}
.filters-section .search-filter .search-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.filters-section .search-filter .search-field ::ng-deep .mat-mdc-form-field-infix {
  min-height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.filters-section .search-filter .search-field ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 20px;
}
.filters-section .search-filter .search-field ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {
  --mat-mdc-form-field-label-transform: translateY(-26.75px) scale(var(--mat-mdc-form-field-floating-label-scale, 0.75));
  transform: var(--mat-mdc-form-field-label-transform);
}
.filters-section .flow-filter {
  display: flex;
  align-items: center;
  min-width: 200px;
  max-width: 240px;
  overflow: visible;
}
.filters-section .flow-filter .status-filter {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #fff;
  font-size: 14px;
}

/* Access Requests dialog sizing/alignment overrides */
::ng-deep .access-requests-dialog .confirmation-dialog {
  max-width: 560px;
}

/* Reduce overall height and inner paddings */
::ng-deep .access-requests-dialog .confirmation-content {
  padding: 12px 16px !important;
  max-height: 62vh; /* reduce content height */
}

/* Tighten comment form spacing */
::ng-deep .access-requests-dialog .comment-form-section {
  margin: 12px 16px !important;
  padding: 12px !important;
}

/* Compact header */
::ng-deep .access-requests-dialog .dialog-header {
  padding: 12px 16px 8px !important;
}

/* Sticky actions with correct alignment and spacing */
::ng-deep .access-requests-dialog mat-dialog-actions.mat-dialog-actions {
  padding: 10px 16px !important;
  gap: 8px !important;
  justify-content: flex-end !important;
  align-items: center !important;
}

/* Normalize buttons: same height and min-width */
::ng-deep .access-requests-dialog mat-dialog-actions .mat-mdc-button-base {
  height: 36px !important;
  min-width: 110px !important;
  padding: 0 14px !important;
}

/* Ensure cancel has border and sits inline neatly */
::ng-deep .access-requests-dialog button.mat-button.cancel-btn {
  border: 1px solid #ddd !important;
}

@media (max-width: 600px) {
  ::ng-deep .access-requests-dialog .confirmation-dialog {
    max-width: calc(100vw - 24px);
  }
  ::ng-deep .access-requests-dialog .confirmation-content {
    max-height: calc(100vh - 160px);
  }
  ::ng-deep .access-requests-dialog mat-dialog-actions.mat-dialog-actions {
    flex-direction: column;
    align-items: stretch !important;
  }
  ::ng-deep .access-requests-dialog mat-dialog-actions .mat-mdc-button-base {
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .followers-tag {
    flex-wrap: wrap;
  }
  .dashbored-wrap .followers-tag .box {
    margin: 0px;
    width: 100%;
  }
  .dashbored-wrap .followers-tag .box .text {
    flex: 1;
  }
  .dashbored-wrap .com-record {
    padding: 15px;
  }
  .dashbored-wrap .com-record:after {
    height: 130px;
  }
  .dashbored-wrap .search-container .search-input {
    display: none;
  }
  .dashbored-wrap .top-menu-wrap {
    display: none;
  }
  .dashbored-wrap .table-wrap {
    top: unset;
    /* keep default hidden tables, but allow inside mobile section */
  }
  .dashbored-wrap .table-wrap .table-parent {
    display: none;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px 10px;
    background: #f8f9fa;
    display: block;
    /* Hide search bar on mobile */
    /* Re-enable table UI within the mobile-design wrapper */
  }
  .dashbored-wrap .mobile-design .filter .input,
  .dashbored-wrap .mobile-design .filter .search-container {
    display: none !important;
  }
  .dashbored-wrap .mobile-design .table-parent {
    display: block !important;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .dashbored-wrap .mobile-design .table-card {
    display: block !important;
  }
  .dashbored-wrap .mobile-design table {
    display: table !important;
    width: 100%;
  }
  .dashbored-wrap .mobile-design .tile {
    background: #fff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #e9ecef;
  }
  .dashbored-wrap .mobile-design .tile > div {
    border-bottom: 1px solid #e9ecef;
    padding: 8px 0;
  }
  .dashbored-wrap .mobile-design .tile > div:last-child {
    border-bottom: none;
  }
  .dashbored-wrap .mobile-design .tile p {
    color: #5ea1d8 !important;
    margin: 2px 0;
  }
  .dashbored-wrap .mobile-design .tile p.bold {
    font-weight: 600 !important;
    font-family: "Raleway", Arial, Helvetica, sans-serif !important;
    color: #333 !important;
  }
  .dashbored-wrap .mobile-design .tile .main-title {
    display: flex;
    align-items: center;
    background: #5ea1d8;
    padding: 12px 15px;
    margin: -15px -15px 15px -15px;
    border-radius: 8px 8px 0 0;
  }
  .dashbored-wrap .mobile-design .tile .main-title h3 {
    margin-bottom: 0px !important;
    color: #fff !important;
    font-family: "Raleway", Arial, Helvetica, sans-serif !important;
    font-weight: 500 !important;
  }
  .dashbored-wrap .mobile-design .first-tile {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
  }
  .dashbored-wrap .mobile-design .first-tile div {
    display: flex;
    align-items: center;
    flex: 1;
  }
  .dashbored-wrap .mobile-design .first-tile div span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  .dashbored-wrap .mobile-design .first-tile input {
    position: relative;
    margin: 0px 10px 0px 0px;
    width: 20px;
    height: 20px;
  }
  .dashbored-wrap .mobile-design .first-tile .img {
    display: flex;
    align-items: flex-start;
    margin-left: 15px;
  }
  .dashbored-wrap .mobile-design .first-tile .img .bundle {
    width: 30px;
    margin-right: 10px;
    height: 30px;
  }
  .dashbored-wrap .mobile-design .first-tile .img img {
    width: 80px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #e9ecef;
  }
  .dashbored-wrap .mobile-design .common-tile {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .dashbored-wrap .mobile-design .common-tile .title-tile {
    flex: 1;
    min-width: 120px;
    padding: 8px 0;
  }
  .dashbored-wrap .mobile-design .common-tile .title-tile p:first-child {
    font-size: 12px;
    color: #6c757d !important;
    margin-bottom: 4px;
    text-transform: none;
    letter-spacing: normal;
  }
  .dashbored-wrap .mobile-design .common-tile .title-tile p.bold {
    font-size: 14px;
    line-height: 1.4;
  }
}
/* new setting common design starts here*/
.setting-dashboard {
  padding: 0;
  height: auto;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}
.setting-dashboard .left-user {
  background: #5ea1d8;
  position: relative;
  padding: 0 0 0 30px;
  position: fixed;
  top: 120px;
  height: calc(100vh - 100px);
  z-index: 3;
}
.setting-dashboard .left-user .collapse-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  background: #5ea1d8;
  border-radius: 50%;
  right: -12.5px;
  top: 26px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transform: rotate(180deg);
}
.setting-dashboard .left-user .dash-elemenet {
  height: calc(100vh - 180px);
}
.setting-dashboard .left-user .dash-elemenet ul {
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style-type: none;
}
.setting-dashboard .left-user .dash-elemenet ul li {
  height: 40px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.5s linear;
  padding-left: 10px;
}
.setting-dashboard .left-user .dash-elemenet ul li:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #1d67a3;
  transition: all 0.5s linear;
  width: 0;
  z-index: -1;
}
.setting-dashboard .left-user .dash-elemenet ul li:hover:after, .setting-dashboard .left-user .dash-elemenet ul li:active:after, .setting-dashboard .left-user .dash-elemenet ul li:focus:after {
  content: "";
  width: 100%;
  left: 0;
  transition: all 0.5s linear;
}

.dashbored-wrap {
  padding-left: 0px;
  margin-top: 0;
}

.setting-dashboard .left-user .dash-title {
  position: unset;
  width: 100%;
}

.setting-dashboard .dash-title {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 2;
  top: calc(var(--app-header) + 24px);
}

.setting-dashboard .dash-title h6,
.setting-dashboard .dash-title .h6 {
  display: flex;
  align-items: center;
  font-weight: 500 !important;
  color: #fff !important;
}

.setting-dashboard .dash-title h6 span,
.setting-dashboard .dash-title .h6 span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

.setting-dashboard .dash-elemenet {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}

.setting-dashboard .dash-elemenet > div {
  width: 100%;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
  transition: all 0.5slinear;
  position: relative;
  padding-bottom: 0;
  z-index: 2;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.left-user .selected-item {
  background: #1d67a3 !important;
  padding-left: 10px;
}

.setting-dashboard .left-user .dash-elemenet > div span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

/*right section*/
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important; /* match landing page */
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0; /* match landing page padding */
}

.mat-mdc-tab-group {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.setting-dashboard .dash-elemenet > div:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #6322b2;
  transition: width 0.5sease 0s, left 0.5sease 0s;
  width: 0;
  z-index: -1;
}

.setting-dashboard .dash-elemenet > div span:last-child {
  font-size: 12px !important;
}

@media (max-width: 767px) {
  .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .mob-menu {
    background: #5d9fd5 !important;
    position: sticky;
    top: var(--app-header, 56px);
    z-index: 1500;
    width: 100%;
    display: block !important;
  }
  .navbar {
    justify-content: flex-start;
    margin-bottom: 0px;
  }
  .mob-menu button {
    background: #5d9fd5 !important;
    margin-bottom: 0 !important;
    color: #fff;
    font-size: 14px;
    padding: 10px 5px;
    text-transform: capitalize;
    border: 1px solid #fff !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center;
  }
  .setting-dashboard .left-user {
    width: 59vw;
    position: fixed;
    top: calc(var(--app-header, 56px) + 48px);
    height: calc(100vh - (var(--app-header, 56px) + 48px));
    padding-left: 10px;
    left: -59vw;
    transition: left 0.5s linear;
    display: block !important;
    z-index: 1600;
  }
  .setting-dashboard .show-menu .left-user {
    left: 0px;
    transition: left 0.5s linear;
  }
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .table-wrap {
    padding: 0px;
  }
  .setting-dashboard .submission-field .hamburger .dash-title {
    width: 100%;
    top: calc(var(--app-header, 56px) + 48px);
    height: 40px;
  }
  .setting-dashboard .left-user .dash-title {
    display: none;
  }
  .setting-dashboard .left-user .collapse-btn {
    display: none;
  }
  .dashbored-wrap {
    margin-top: 10px !important;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px;
  }
  .dashbored-wrap .com-record:after {
    height: 133px;
  }
  /* Search and filter bar: full width on mobile */
  .filter,
  .filters-section {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .filters-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 16px;
    padding: 0 20px;
  }
  .filters-section .search-filter {
    flex: 1 1 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .filters-section .search-field,
  .filters-section .search-field ::ng-deep .mat-mdc-form-field,
  .filters-section .search-field ::ng-deep .mat-mdc-text-field-wrapper {
    width: 100% !important;
    max-width: 100% !important;
  }
  .filters-section .flow-filter {
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .filters-section .flow-filter mat-form-field,
  .filters-section .flow-filter .status-filter,
  .filters-section .flow-filter ::ng-deep .mat-mdc-form-field {
    width: 100% !important;
    max-width: 100% !important;
  }
}
.skeleton-stats-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  width: 100%;
}

.skeleton-box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
  min-width: 150px;
  flex: 1;
}

.skeleton-table-container {
  margin: 16px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  width: 100%;
  min-height: 300px;
  overflow-x: auto;
}

.skeleton-mobile-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  width: 100%;
  min-height: 400px;
}

.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  height: 16px;
  margin: 4px 0;
}
.skeleton-text.skeleton-title {
  height: 20px;
  width: 80%;
}
.skeleton-text.skeleton-bold {
  height: 18px;
  width: 60%;
}

.skeleton-checkbox {
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 3px;
  margin-right: 10px;
}

.skeleton-icon {
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 50%;
}

.skeleton-image {
  width: 100%;
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  object-fit: cover;
}

.skeleton-price {
  width: 60px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-left: 10px;
}

.skeleton-analytics {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.skeleton-tile {
  background: #fff;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 12px;
  width: 100%;
}
.skeleton-tile .main-title {
  display: flex;
  align-items: center;
  background: #5ea1d8;
  padding: 10px;
  margin-bottom: 10px;
}
.skeleton-tile .main-title .skeleton-title {
  height: 24px;
  width: 70%;
}
.skeleton-tile .first-tile div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.skeleton-tile .first-tile .img {
  display: flex;
  align-items: flex-start;
}
.skeleton-tile .first-tile .img .bundle {
  width: 30px;
  margin-right: 10px;
  height: 30px;
}
.skeleton-tile .common-tile {
  display: flex;
}
.skeleton-tile .common-tile .title-tile {
  flex: 1;
  padding: 3px;
}

@keyframes skeleton-loading {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@media (max-width: 768px) {
  .skeleton-stats-container {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
    width: 100%;
    min-height: 150px;
  }
  .skeleton-table-container {
    padding: 12px;
    margin: 12px 0;
    width: 100%;
    min-height: 250px;
    display: block;
  }
  .skeleton-mobile-container {
    padding: 12px;
    margin: 12px 0;
    width: 100%;
    min-height: 300px;
    display: flex;
  }
}
@media (max-width: 480px) {
  .skeleton-stats-container {
    padding: 8px;
    gap: 8px;
    min-height: 120px;
  }
  .skeleton-table-container,
  .skeleton-mobile-container {
    padding: 8px;
    margin: 8px 0;
  }
  .skeleton-table-container {
    min-height: 200px;
  }
  .skeleton-mobile-container {
    min-height: 250px;
  }
}
.filter .view-toggle {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.filter .view-toggle button {
  color: #5ea1d8;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding: 0 !important;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  min-height: 40px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.filter .view-toggle button:hover {
  background-color: rgba(94, 161, 216, 0.1) !important;
}
.filter .view-toggle button:focus {
  outline: none !important;
  background-color: rgba(94, 161, 216, 0.18) !important;
}
.filter .view-toggle button mat-icon {
  font-size: 22px !important;
  width: 22px !important;
  height: 22px !important;
  line-height: 22px !important;
}

.access-requests-list-card {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 20px;
}
.access-requests-list-card .loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}
.access-requests-list-card .loading-section p {
  margin-top: 16px;
  color: #666;
}
.access-requests-list-card .no-requests {
  text-align: center;
  padding: 60px 20px;
}
.access-requests-list-card .no-requests mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #ccc;
  margin-bottom: 16px;
}
.access-requests-list-card .no-requests h3 {
  margin: 0 0 8px 0;
  color: #666;
}
.access-requests-list-card .no-requests p {
  margin: 0;
  color: #999;
}
.access-requests-list-card .request-card-modern {
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  box-sizing: border-box;
}
.access-requests-list-card .request-card-modern:hover {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
}
.access-requests-list-card .request-card-modern .card-content {
  padding: 24px;
}
.access-requests-list-card .request-card-modern .request-header-modern {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
@media (min-width: 640px) {
  .access-requests-list-card .request-card-modern .request-header-modern {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
}
.access-requests-list-card .request-card-modern .request-header-modern .requester-info-modern {
  display: flex;
  align-items: center;
  gap: 12px;
}
.access-requests-list-card .request-card-modern .request-header-modern .requester-info-modern .requester-avatar-modern {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 16px;
  background-color: #5ea1d8;
  flex-shrink: 0;
}
.access-requests-list-card .request-card-modern .request-header-modern .requester-info-modern .requester-details-modern {
  display: flex;
  flex-direction: column;
}
.access-requests-list-card .request-card-modern .request-header-modern .requester-info-modern .requester-details-modern .requester-name-modern {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
}
.access-requests-list-card .request-card-modern .request-header-modern .requester-info-modern .requester-details-modern .requester-email-modern {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #94a3b8;
}
.access-requests-list-card .request-card-modern .request-header-modern .requester-info-modern .requester-details-modern .requester-username-modern {
  margin: 2px 0 0 0;
  font-size: 12px;
  color: #64748b;
}
.access-requests-list-card .request-card-modern .request-header-modern .status-badge-modern {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.access-requests-list-card .request-card-modern .request-header-modern .status-badge-modern.status-pending {
  background-color: #fef3c7;
  color: #d97706 !important;
}
.access-requests-list-card .request-card-modern .request-header-modern .status-badge-modern.status-approved {
  background-color: #dcfce7;
  color: #16a34a !important;
}
.access-requests-list-card .request-card-modern .request-header-modern .status-badge-modern.status-rejected {
  background-color: #fee2e2;
  color: #dc2626 !important;
}
.access-requests-list-card .request-card-modern .request-content-modern {
  margin-bottom: 24px;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-field {
  margin-bottom: 16px;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-field label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin-bottom: 8px;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-field p {
  margin: 0 0 12px 0;
  color: #334155;
  line-height: 1.6;
  font-size: 15px;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-field p.flow-link-modern {
  color: #5ea1d8;
  cursor: pointer;
  font-weight: 500;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-field p.flow-link-modern:hover {
  text-decoration: underline;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-field .response-message {
  background-color: #f8fafc;
  border-left: 3px solid #5ea1d8;
  padding: 12px;
  border-radius: 4px;
  margin-top: 8px;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-field .response-message p {
  margin: 0 0 8px 0;
  color: #334155;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-field .response-message .response-date {
  font-size: 12px;
  color: #94a3b8;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-details-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
@media (min-width: 640px) {
  .access-requests-list-card .request-card-modern .request-content-modern .request-details-grid {
    grid-template-columns: 1fr 1fr;
  }
}
.access-requests-list-card .request-card-modern .request-content-modern .request-details-grid .detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-details-grid .detail-item label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
}
.access-requests-list-card .request-card-modern .request-content-modern .request-details-grid .detail-item span {
  font-size: 14px;
  color: #334155;
  font-weight: 500;
}
.access-requests-list-card .request-card-modern .request-actions-modern {
  display: flex;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}
.access-requests-list-card .request-card-modern .request-actions-modern button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.access-requests-list-card .request-card-modern .request-actions-modern button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

@media (max-width: 768px) {
  .access-requests-list-card .request-card-modern {
    border-radius: 12px;
  }
  .access-requests-list-card .request-card-modern .card-content {
    padding: 16px;
  }
  .access-requests-list-card .request-card-modern .request-header-modern {
    flex-direction: column;
    gap: 12px;
  }
  .access-requests-list-card .request-card-modern .request-content-modern .request-details-grid {
    grid-template-columns: 1fr;
  }
  .access-requests-list-card .request-card-modern .request-actions-modern {
    flex-direction: column;
  }
}
:host-context(body.theme-dark) .dashbored-wrap,
:host-context(body.theme-dark) .setting-dashboard,
:host-context(body.theme-dark) .scroll-div,
:host-context(body.theme-dark) .com-record,
:host-context(body.theme-dark) .table-wrap,
:host-context(body.theme-dark) .filter,
:host-context(body.theme-dark) .filters-section,
:host-context(body.theme-dark) .search-input,
:host-context(body.theme-dark) .detail-list {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .filters-section .status-filter {
  background: #0f172a !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) table, :host-context(body.theme-dark) thead, :host-context(body.theme-dark) tbody, :host-context(body.theme-dark) tr, :host-context(body.theme-dark) td {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) th {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) tbody tr:hover {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .box {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) p, :host-context(body.theme-dark) span:not(.material-icons):not(.status-badge-modern):not([class*=badge]):not([class*=status-]), :host-context(body.theme-dark) label, :host-context(body.theme-dark) li, :host-context(body.theme-dark) h1, :host-context(body.theme-dark) h2, :host-context(body.theme-dark) h3, :host-context(body.theme-dark) h4, :host-context(body.theme-dark) h5, :host-context(body.theme-dark) h6, :host-context(body.theme-dark) i, :host-context(body.theme-dark) b {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .mobile-design {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .mobile-design .tile {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .skeleton-text {
  background: linear-gradient(90deg, #1f2937 25%, #374151 37%, #1f2937 63%) !important;
  background-size: 400% 100% !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .requester-name-modern {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .requester-email-modern,
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .requester-username-modern {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .request-field label {
  color: #64748b !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .request-field p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .response-message {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .response-message p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .response-message .response-date {
  color: #64748b !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .detail-item label {
  color: #64748b !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .detail-item span {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .access-requests-list-card .request-card-modern .request-actions-modern {
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .dashbored-wrap,
body.theme-dark .setting-dashboard {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .top-menu-wrap,
body.theme-dark .dashbored-wrap .box,
body.theme-dark .dashbored-wrap .card,
body.theme-dark .dashbored-wrap .mat-mdc-card,
body.theme-dark .dashbored-wrap .tile,
body.theme-dark .dashbored-wrap .com-record,
body.theme-dark .dashbored-wrap .table-wrap,
body.theme-dark .dashbored-wrap .detail-list,
body.theme-dark .dashbored-wrap .filter,
body.theme-dark .dashbored-wrap .search-input,
body.theme-dark .dashbored-wrap .tab-content,
body.theme-dark .dashbored-wrap .followers-tag .box {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap table,
body.theme-dark .dashbored-wrap thead,
body.theme-dark .dashbored-wrap tbody,
body.theme-dark .dashbored-wrap tr,
body.theme-dark .dashbored-wrap td {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap th {
  background: var(--fc-bg-head) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap tbody tr:hover {
  background: var(--fc-bg-hover) !important;
}

body.theme-dark .dashbored-wrap input,
body.theme-dark .dashbored-wrap select,
body.theme-dark .dashbored-wrap textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap .mobile-design {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .mobile-design .tile {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap [class*=skeleton-] {
  background: var(--fc-skel) !important;
  color: transparent !important;
}

body.theme-dark .dashbored-wrap p,
body.theme-dark .dashbored-wrap label,
body.theme-dark .dashbored-wrap li,
body.theme-dark .dashbored-wrap h1,
body.theme-dark .dashbored-wrap h2,
body.theme-dark .dashbored-wrap h3,
body.theme-dark .dashbored-wrap h4,
body.theme-dark .dashbored-wrap h5,
body.theme-dark .dashbored-wrap h6 {
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=status]) {
  color: var(--fc-fg) !important;
}

/* ── Direct body.theme-dark additions (access-requests page) ── */
body.theme-dark .access-requests-list-card .request-card-modern {
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .requester-name-modern {
  color: #f1f5f9 !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .requester-email-modern,
body.theme-dark .access-requests-list-card .request-card-modern .requester-username-modern {
  color: #94a3b8 !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .request-field label {
  color: #64748b !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .request-field p {
  color: #cbd5e1 !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .response-message {
  background: #0f172a !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .response-message p {
  color: #cbd5e1 !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .response-message .response-date {
  color: #64748b !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .detail-item label {
  color: #64748b !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .detail-item span {
  color: #f1f5f9 !important;
}

body.theme-dark .access-requests-list-card .request-card-modern .request-actions-modern {
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .followers-tag .box .text .count {
  background: transparent !important;
}

body.theme-dark .followers-tag .box .text .count b {
  color: #f1f5f9 !important;
}

body.theme-dark .followers-tag .box .text p {
  color: #94a3b8 !important;
}

body.theme-dark .filters-section .status-filter {
  background: #0f172a !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

body.theme-dark .responsive-tabel th {
  background-color: var(--fc-bg-head) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .responsive-tabel td {
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .skeleton-box {
  background: var(--fc-bg2) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .skeleton-table-container,
body.theme-dark .skeleton-mobile-container {
  background: var(--fc-bg2) !important;
}

body.theme-dark .skeleton-tile {
  background: var(--fc-bg2) !important;
  border-color: var(--fc-border) !important;
}

/* ── Override global white-background globals (.fc-table, .big-box, .filter-section) ── */
body.theme-dark .big-box {
  background: #111827 !important;
  background-color: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .fc-table {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .fc-table thead th {
  background-color: #0f172a !important;
  background: #0f172a !important;
  color: #94a3b8 !important;
  border-bottom-color: rgba(148, 163, 184, 0.25) !important;
  border-right-color: rgba(148, 163, 184, 0.15) !important;
}

body.theme-dark .fc-table tbody td {
  background-color: #1f2937 !important;
  color: #e2e8f0 !important;
  border-top-color: rgba(148, 163, 184, 0.15) !important;
  border-right-color: rgba(148, 163, 184, 0.1) !important;
}

body.theme-dark .fc-table tbody tr:nth-child(even) td {
  background-color: #253347 !important;
}

body.theme-dark .fc-table tbody tr:hover td {
  background-color: #374151 !important;
  color: #f1f5f9 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

body.theme-dark .filter-section {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .filter-section label {
  color: #94a3b8 !important;
}

body.theme-dark .filter-section select,
body.theme-dark .filter-section input {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

/* ── Stat card count white-bg fix (highest specificity override) ── */
body.theme-dark .com-record .followers-tag .box {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .com-record .followers-tag .box .text .count {
  background: transparent !important;
  background-color: transparent !important;
}

body.theme-dark .com-record .followers-tag .box .text .count b {
  color: #f1f5f9 !important;
}

body.theme-dark .com-record .followers-tag .box .text p {
  color: #94a3b8 !important;
}

body.theme-dark .com-record .followers-tag .box .card-icon {
  color: #5ea1d8 !important;
}

/* ── Dark scrollbars and overflow area fix ── */
body.theme-dark .table-parent {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .table-parent::-webkit-scrollbar,
body.theme-dark .table-card::-webkit-scrollbar {
  background: #111827;
  width: 6px;
  height: 6px;
}

body.theme-dark .table-parent::-webkit-scrollbar-track,
body.theme-dark .table-card::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb,
body.theme-dark .table-card::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,
body.theme-dark .table-card::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

body.theme-dark .table-parent::-webkit-scrollbar-corner,
body.theme-dark .table-card::-webkit-scrollbar-corner {
  background: #111827;
}

/* ── Status badge dark mode overrides ── */
body.theme-dark .status-badge-modern.status-pending {
  background-color: #451a03 !important;
  color: #fcd34d !important;
  border-color: rgba(252, 211, 77, 0.3) !important;
}

body.theme-dark .status-badge-modern.status-approved {
  background-color: #052e16 !important;
  color: #86efac !important;
  border-color: rgba(134, 239, 172, 0.3) !important;
}

body.theme-dark .status-badge-modern.status-rejected {
  background-color: #450a0a !important;
  color: #fca5a5 !important;
  border-color: rgba(252, 165, 165, 0.3) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/access-requests/access-requests.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,0EAAA;AAEA,yBAAA;AACA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA,6BAAA;AACA;EACE,iCAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,0BAAA;EACA,+BAAA;AACF;;AAEA;EACE,oCAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;AACF;;AAEA;EACE,oCAAA;EACA,sCAAA;EACA,wDAAA;AACF;;AAEA;EACE,oCAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;AACF;;AAEA;EACE,oCAAA;EACA,sCAAA;EACA,uDAAA;AACF;;AAEA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;AACF;;AAEA,oDAAA;AACA;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA,2CAAA;AACA;;;;;;;;;;;EAWE,+DAAA;AAAF;;AAGA,4CAAA;AACA;EACE,+DAAA;AAAF;AAEE;;EAEE,+DAAA;EACA,0BAAA;AAAJ;AAGE;EACE,2BAAA;EACA,sBAAA;EACA,oCAAA;EACA,oCAAA;EACA,0BAAA;EACA,gCAAA;EACA,wBAAA;EACA,2CAAA;AADJ;AAIE;EACE,2BAAA;EACA,sBAAA;AAFJ;;AAMA,kDAAA;AACA;EACE,+DAAA;AAHF;AAKE;;;EAGE,+DAAA;AAHJ;AAME;EACE,2BAAA;AAJJ;;AAQA,0CAAA;AACA;EACE;IACE,cAAA;EALF;EAQA;IACE,aAAA;EANF;AACF;AASA;EACE;IACE,aAAA;EAPF;EAUA;IACE,cAAA;EARF;AACF;AAWA,8BAAA;AACA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,cAAA;AATF;;AAWA;EACE;IACE,aAAA;EARF;AACF;AAWA,+DAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;AATF;AAaQ;EACE,6BAAA;AAXV;;AAkBA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAfF;;AAkBA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AAfF;;AAkBA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,iCAAA;AAfF;;AAkBA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;EAEA,SAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,uBAAA,EAAA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,QAAA;AAhBF;;AAmBA;EACE,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,eAAA,EAAA,iCAAA;EACA,2BAAA,EAAA,wBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAhBF;;AAmBA,yCAAA;AACA;EACE;IACE,SAAA;EAhBF;EAkBA;IACE,WAAA;IACA,aAAA;IACA,eAAA;IACA,kBAAA;EAhBF;EAkBA;IACE,WAAA;IACA,YAAA;EAhBF;EAkBA;IACE,0BAAA;EAhBF;EAkBA;IACE,eAAA;EAhBF;AACF;AAmBA;EACE;IACE,0BAAA;IACA,2BAAA;EAjBF;AACF;AAmBA,2BAAA;AACA;EACE,aAAA;EACA,mBAAA;AAjBF;;AAmBA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AAhBF;;AAkBA;EACE,yBAAA;EACA,YAAA;AAfF;;AAiBA,eAAA;AACA;EACE,yBAAA;EACA,WAAA;AAdF;;AAiBA;;EAEE,sBAAA;EACA,YAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,gCAAA;AAdF;;AAiBA;EACE,aAAA;EACA,gCAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,yBAAA;AAdF;;AAiBA;EACE,4BAAA;EACA,iBAAA;AAdF;;AAgBA;EACE,gBAAA;AAbF;;AAeA;EACE,kBAAA;AAZF;;AAeA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AAZF;AAaE;EACE,YAAA;EACA,mBAAA;AAXJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAXJ;AAaE;EACE,aAAA;EACA,mBAAA;AAXJ;AAaE;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AAXJ;AAaE;EACE,aAAA;EACA,mBAAA;AAXJ;AAaE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAXJ;AAcE;EACE,WAAA;EACA,aAAA;EAEA,gBAAA;AAbJ;AAeE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,uBAAA;AAdJ;AAgBE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;EACA,2BAAA;AAdJ;AAgBE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAdJ;AAgBE;EACE,mBAAA;AAdJ;AAsBE;EACE,mBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AArBJ;AAuBE;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,WAAA;AArBJ;AAuBE;EACE,WAAA;AArBJ;AAuBE;EACE;mBAAA;EAEA,WAAA;AArBJ;AAuBE;EACE,WAAA;AArBJ;AAuBE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EAEA,kBAAA;EAGA,wBAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AAzBJ;AA2BE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAzBJ;AA2BE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AAzBJ;AAkCU;EACE,6BAAA;AAhCZ;AAsCE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AApCJ;AAsCE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCJ;AAsCE;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;AApCJ;AAsCE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,oDAAA;AApCJ;AAsCE;EACE,YAAA;AApCJ;AAsCE;EACE,WAAA;AApCJ;AAsCE;EACE,mBAAA;AApCJ;AAsCE;EACE,gBAAA;EACA,gBAAA;EAEA,gBAAA;AArCJ;AAuCE;EACE,mBAAA;EAGA,gBAAA;EACA,kBAAA;EACA,WAAA;EAEA,gBAAA;EACA,WAAA;AAxCJ;AA0CE;;EAEE,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAxCJ;AA0CE;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,gCAAA;AAxCJ;AA0CE;EACE,aAAA;EACA,gCAAA;EACA,sBAAA;AAxCJ;AA0CE;EACE,kBAAA;AAxCJ;AA0CE;EACE,WAAA;EACA,kBAAA;AAxCJ;AAyCI;EACE,YAAA;EACA,WAAA;AAvCN;AAwCM;EACE,WAAA;AAtCR;AA0CE;EACE,eAAA;EACA,iCAAA;AAxCJ;AA4CI;EACE,yBAAA;AA1CN;AA2CM;EACE,WAAA;AAzCR;AA4CI;EACE,mBAAA;AA1CN;AA4CI;EACE,aAAA;EACA,mBAAA;AA1CN;AAqDE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAnDJ;AAuDE;EACE,OAAA;AArDJ;AAuDE;EACE,aAAA;EACA,YAAA;AArDJ;AAuDE;EACE,aAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AArDJ;AAuDE;EACE,cAAA;AArDJ;AAuDE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;AArDJ;AAuDE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;AArDJ;AAuDI;EACE,WAAA;AArDN;AAyDE;EACE,aAAA;AAvDJ;AAyDM;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAvDR;AAwDQ;EACE,kBAAA;AAtDV;AAyDM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAvDR;AA4DI;EACE,eAAA;EACA,gBAAA;EAEA,iBAAA;AA3DN;AAoEE;EACE,aAAA;AAlEJ;;AAsEA,0CAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAnEF;AAqEE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAnEJ;AAqEI;EACE,WAAA;AAnEN;AAqEM;EACE,WAAA;AAnER;AAsEM;EACE,WAAA;AApER;AAuEM;EACE,aAAA;AArER;AAwEM;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAtER;AAyEM;EACE,SAAA;AAvER;AA0EM;EACE,sHAAA;EACA,oDAAA;AAxER;AA6EE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AA3EJ;AA6EI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AA3EN;;AAgFA,sDAAA;AACA;EACE,gBAAA;AA7EF;;AAgFA,6CAAA;AACA;EACE,6BAAA;EACA,gBAAA,EAAA,0BAAA;AA7EF;;AAgFA,iCAAA;AACA;EACE,4BAAA;EACA,wBAAA;AA7EF;;AAgFA,mBAAA;AACA;EACE,iCAAA;AA7EF;;AAgFA,sDAAA;AACA;EACE,6BAAA;EACA,mBAAA;EACA,oCAAA;EACA,8BAAA;AA7EF;;AAgFA,iDAAA;AACA;EACE,uBAAA;EACA,2BAAA;EACA,0BAAA;AA7EF;;AAgFA,oDAAA;AACA;EACE,iCAAA;AA7EF;;AAgFA;EACE;IACE,6BAAA;EA7EF;EA+EA;IACE,+BAAA;EA7EF;EA+EA;IACE,sBAAA;IACA,+BAAA;EA7EF;EA+EA;IACE,sBAAA;EA7EF;AACF;AA+EA;EAEI;IACE,aAAA;EA9EJ;EAgFE;IACE,WAAA;IACA,SAAA;EA9EJ;EAgFE;IACE,eAAA;EA9EJ;EA+EI;IACE,WAAA;IACA,WAAA;EA7EN;EA8EM;IACE,OAAA;EA5ER;EAgFE;IACE,aAAA;EA9EJ;EAgFI;IACE,aAAA;EA9EN;EAqFI;IACE,aAAA;EAnFN;EAsFE;IACE,aAAA;EApFJ;EAsFE;IACE,UAAA;IACA,gEAAA;EApFJ;EAqFI;IACE,aAAA;EAnFN;EAsFE;IACE,kBAAA;IACA,mBAAA;IACA,cAAA;IACA,8BAAA;IAOA,wDAAA;EA1FJ;EAqFM;;IAEE,wBAAA;EAnFR;EAuFI;IACE,yBAAA;IACA,gBAAA;IACA,iCAAA;EArFN;EAuFI;IACE,yBAAA;EArFN;EAuFI;IACE,yBAAA;IACA,WAAA;EArFN;EAuFI;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,kBAAA;IACA,wCAAA;IACA,yBAAA;EArFN;EAsFM;IACE,gCAAA;IACA,cAAA;EApFR;EAqFQ;IACE,mBAAA;EAnFV;EAsFM;IACE,yBAAA;IACA,aAAA;EApFR;EAsFM;IACE,2BAAA;IACA,+DAAA;IACA,sBAAA;EApFR;EAsFM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;IACA,8BAAA;IACA,0BAAA;EApFR;EAqFQ;IACE,6BAAA;IACA,sBAAA;IACA,+DAAA;IACA,2BAAA;EAnFV;EAuFI;IACE,aAAA;IACA,8BAAA;IACA,uBAAA;IACA,mBAAA;EArFN;EAuFM;IACE,aAAA;IACA,mBAAA;IACA,OAAA;EArFR;EAsFQ;IACE,aAAA;IACA,mBAAA;IACA,iBAAA;EApFV;EAwFM;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EAtFR;EAyFM;IACE,aAAA;IACA,uBAAA;IACA,iBAAA;EAvFR;EAwFQ;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EAtFV;EAwFQ;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,kBAAA;IACA,yBAAA;EAtFV;EA0FI;IACE,aAAA;IACA,eAAA;IACA,SAAA;EAxFN;EAyFM;IACE,OAAA;IACA,gBAAA;IACA,cAAA;EAvFR;EAwFQ;IACE,eAAA;IACA,yBAAA;IACA,kBAAA;IACA,oBAAA;IACA,sBAAA;EAtFV;EAwFQ;IACE,eAAA;IACA,gBAAA;EAtFV;AACF;AA6FA,yCAAA;AAEA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AA5FF;AA6FE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AA3FJ;AA6FE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,2BAAA;EACA,UAAA;AA3FJ;AA4FI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AA1FN;AA4FI;EACE,2BAAA;AA1FN;AA2FM;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AAzFR;AA0FQ;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAxFV;AAyFU;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AAvFZ;AAyFU;EAGE,WAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;AAzFZ;;AAgGA;EACE,iBAAA;EACA,aAAA;AA7FF;;AAgGA;EACE,eAAA;EACA,WAAA;AA7FF;;AA+FA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,mCAAA;AA5FF;;AA8FA;;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AA3FF;;AA6FA;;EAEE,sBAAA;EACA,eAAA;EACA,kBAAA;AA1FF;;AA6FA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA1FF;;AA4FA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAzFF;;AA2FA;EACE,8BAAA;EACA,kBAAA;AAxFF;;AA0FA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AAvFF;;AA0FA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAvFF;;AAyFA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAtFF;;AAwFA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EAEA,WAAA;EAEA,iBAAA;AAvFF;;AAyFA;EACE,gBAAA;EACA,iCAAA,EAAA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAtFF;AAuFE;EACE,oBAAA,EAAA,+BAAA;AArFJ;;AAyFA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAtFF;;AAyFA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,QAAA;EACA,WAAA;AAtFF;;AAwFA;EACE,0BAAA;AArFF;;AAwFA;EACE;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EArFF;EAwFA;IACE,8BAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;EAtFF;EAwFA;IACE,2BAAA;IACA,kBAAA;EAtFF;EAwFA;IACE,8BAAA;IACA,2BAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,0BAAA;IACA,iCAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;EAtFF;EAwFA;IACE,WAAA;IACA,eAAA;IACA,yCAAA;IACA,sDAAA;IACA,kBAAA;IACA,WAAA;IACA,4BAAA;IACA,yBAAA;IACA,aAAA;EAtFF;EAwFA;IACE,SAAA;IACA,4BAAA;EAtFF;EAwFA;IACE,WAAA;IACA,SAAA;EAtFF;EAwFA;IACE,YAAA;EAtFF;EAwFA;IACE,WAAA;IACA,yCAAA;IACA,YAAA;EAtFF;EAwFA;IACE,aAAA;EAtFF;EAwFA;IACE,aAAA;EAtFF;EAwFA;IACE,2BAAA;EAtFF;EAwFA;IACE,aAAA;EAtFF;EAwFA;IACE,aAAA;EAtFF;EAyFA,gDAAA;EACA;;IAEE,sBAAA;IACA,0BAAA;IACA,sBAAA;EAvFF;EAyFA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;IACA,eAAA;EAvFF;EAyFA;IACE,yBAAA;IACA,uBAAA;IACA,0BAAA;IACA,sBAAA;EAvFF;EAyFA;;;IAGE,sBAAA;IACA,0BAAA;EAvFF;EAyFA;IACE,uBAAA;IACA,0BAAA;IACA,sBAAA;EAvFF;EAyFA;;;IAGE,sBAAA;IACA,0BAAA;EAvFF;AACF;AA0FA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAxFF;;AA2FA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;EACA,gBAAA;EACA,OAAA;AAxFF;;AA2FA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAxFF;;AA2FA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAxFF;;AA4FA;EACE,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAzFF;AA2FE;EACE,YAAA;EACA,UAAA;AAzFJ;AA4FE;EACE,YAAA;EACA,UAAA;AA1FJ;;AA8FA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;AA3FF;;AA8FA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;AA3FF;;AA8FA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;AA3FF;;AA8FA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;AA3FF;;AA8FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA3FF;;AA8FA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AA3FF;AA6FE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AA3FJ;AA6FI;EACE,YAAA;EACA,UAAA;AA3FN;AAgGI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA9FN;AAiGI;EACE,aAAA;EACA,uBAAA;AA/FN;AAiGM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;AA/FR;AAoGE;EACE,aAAA;AAlGJ;AAoGI;EACE,OAAA;EACA,YAAA;AAlGN;;AAwGA;EACE;IACE,4BAAA;EArGF;EAuGA;IACE,2BAAA;EArGF;AACF;AAyGA;EACE;IACE,0BAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;IACA,iBAAA;EAvGF;EA0GA;IACE,aAAA;IACA,cAAA;IACA,WAAA;IACA,iBAAA;IACA,cAAA;EAxGF;EA2GA;IACE,aAAA;IACA,cAAA;IACA,WAAA;IACA,iBAAA;IACA,aAAA;EAzGF;AACF;AA4GA;EACE;IACE,YAAA;IACA,QAAA;IACA,iBAAA;EA1GF;EA6GA;;IAEE,YAAA;IACA,aAAA;EA3GF;EA8GA;IACE,iBAAA;EA5GF;EA+GA;IACE,iBAAA;EA7GF;AACF;AAkHE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAhHJ;AAkHI;EACE,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AAhHN;AAkHM;EACE,oDAAA;AAhHR;AAmHM;EACE,wBAAA;EACA,qDAAA;AAjHR;AAoHM;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AAlHR;;AAyHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAtHF;AAwHE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAtHJ;AAwHI;EACE,gBAAA;EACA,WAAA;AAtHN;AA0HE;EACE,kBAAA;EACA,kBAAA;AAxHJ;AA0HI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAxHN;AA2HI;EACE,iBAAA;EACA,WAAA;AAzHN;AA4HI;EACE,SAAA;EACA,WAAA;AA1HN;AA8HE;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AA5HJ;AA8HI;EACE,6CAAA;AA5HN;AA+HI;EACE,aAAA;AA7HN;AAgII;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AA9HN;AAgIM;EANF;IAOI,mBAAA;IACA,8BAAA;IACA,uBAAA;EA7HN;AACF;AA+HM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA7HR;AA+HQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AA7HV;AAgIQ;EACE,aAAA;EACA,sBAAA;AA9HV;AAgIU;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA9HZ;AAiIU;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AA/HZ;AAkIU;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAhIZ;AAqIM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAnIR;AAqIQ;EACE,yBAAA;EACA,yBAAA;AAnIV;AAsIQ;EACE,yBAAA;EACA,yBAAA;AApIV;AAuIQ;EACE,yBAAA;EACA,yBAAA;AArIV;AA0II;EACE,mBAAA;AAxIN;AA0IM;EACE,mBAAA;AAxIR;AA0IQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAxIV;AA2IQ;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAzIV;AA2IU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAzIZ;AA2IY;EACE,0BAAA;AAzId;AA8IQ;EACE,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AA5IV;AA8IU;EACE,iBAAA;EACA,cAAA;AA5IZ;AA+IU;EACE,eAAA;EACA,cAAA;AA7IZ;AAkJM;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAhJR;AAkJQ;EALF;IAMI,8BAAA;EA/IR;AACF;AAiJQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA/IV;AAiJU;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AA/IZ;AAkJU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAhJZ;AAsJI;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AApJN;AAsJM;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AApJR;AAsJQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApJV;;AA2JA;EAEI;IACE,mBAAA;EAzJJ;EA2JI;IACE,aAAA;EAzJN;EA4JI;IACE,sBAAA;IACA,SAAA;EA1JN;EA8JM;IACE,0BAAA;EA5JR;EAgKI;IACE,sBAAA;EA9JN;AACF;AAuKE;;;;;;;;;EASE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AArKJ;AAyKE;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAvKJ;AA0KE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAxKJ;AA0KE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAxKJ;AA0KE;EAAiB,8BAAA;AAvKnB;AAyKE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AAvKJ;AA0KE;EACE,yBAAA;AAxKJ;AA2KE;EACE,8BAAA;AAzKJ;AA0KI;EACE,8BAAA;EACA,kDAAA;AAxKN;AA6KE;EAAiB,oFAAA;EAAsF,qCAAA;AAzKzG;AA4KE;EACE,8BAAA;EACA,kDAAA;AA1KJ;AA2KI;EAAyB,yBAAA;AAxK7B;AAyKI;;EAC6B,yBAAA;AAtKjC;AAwKM;EAAQ,yBAAA;AArKd;AAsKM;EAAI,yBAAA;AAnKV;AAqKI;EACE,8BAAA;AAnKN;AAoKM;EAAI,yBAAA;AAjKV;AAkKM;EAAiB,yBAAA;AA/JvB;AAkKM;EAAQ,yBAAA;AA/Jd;AAgKM;EAAO,yBAAA;AA7Jb;AA+JI;EAA0B,iDAAA;AA5J9B;;AAsKA;;EAEE,mCAAA;EACA,8BAAA;AAnKF;;AAsKA;;;;;;;;;;;;EAYE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAnKF;;AAsKA;;;;;EAKE,mCAAA;EACA,8BAAA;EACA,yCAAA;AAnKF;;AAsKA;EACE,wCAAA;EACA,8BAAA;EACA,yCAAA;AAnKF;;AAsKA;EACE,yCAAA;AAnKF;;AAsKA;;;EAGE,8BAAA;EACA,8BAAA;EACA,yCAAA;AAnKF;;AAsKA;EACE,mCAAA;EACA,8BAAA;AAnKF;;AAsKA;EACE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAnKF;;AAsKA;EACE,qCAAA;EACA,6BAAA;AAnKF;;AAsKA;;;;;;;;;EASE,8BAAA;AAnKF;;AAsKA;EACE,8BAAA;AAnKF;;AAsKA,kEAAA;AAEA;EACE,oCAAA;EACA,iDAAA;AApKF;;AAuKA;EACE,yBAAA;AApKF;;AAuKA;;EAEE,yBAAA;AApKF;;AAuKA;EACE,yBAAA;AApKF;;AAuKA;EACE,yBAAA;AApKF;;AAuKA;EACE,8BAAA;AApKF;;AAuKA;EACE,yBAAA;AApKF;;AAuKA;EACE,yBAAA;AApKF;;AAuKA;EACE,yBAAA;AApKF;;AAuKA;EACE,yBAAA;AApKF;;AAuKA;EACE,qDAAA;AApKF;;AAuKA;EACE,kCAAA;AApKF;;AAuKA;EAAqD,yBAAA;AAnKrD;;AAoKA;EAA8C,yBAAA;AAhK9C;;AAkKA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA/JF;;AAkKA;EACE,8CAAA;EACA,8BAAA;EACA,yCAAA;AA/JF;;AAkKA;EACE,8BAAA;EACA,yCAAA;AA/JF;;AAkKA;EACE,oCAAA;EACA,yCAAA;AA/JF;;AAkKA;;EAEE,oCAAA;AA/JF;;AAkKA;EACE,oCAAA;EACA,yCAAA;AA/JF;;AAiKA,0FAAA;AACA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AA9JF;;AAgKA;EACE,8BAAA;EACA,oCAAA;AA7JF;;AA+JA;EACE,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,yDAAA;EACA,wDAAA;AA5JF;;AA8JA;EACE,oCAAA;EACA,yBAAA;EACA,sDAAA;EACA,uDAAA;AA3JF;;AA6JA;EACE,oCAAA;AA1JF;;AA4JA;EACE,oCAAA;EACA,yBAAA;EACA,iDAAA;AAzJF;;AA2JA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AAxJF;;AA0JA;EACE,yBAAA;AAvJF;;AAyJA;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,iDAAA;AAtJF;;AAyJA,sEAAA;AACA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AAtJF;;AAwJA;EACE,kCAAA;EACA,wCAAA;AArJF;;AAuJA;EACE,yBAAA;AApJF;;AAsJA;EACE,yBAAA;AAnJF;;AAqJA;EACE,yBAAA;AAlJF;;AAqJA,gDAAA;AACA;EACE,8BAAA;EACA,oCAAA;AAlJF;;AAoJA;;EAEE,mBAAA;EACA,UAAA;EACA,WAAA;AAjJF;;AAmJA;;EAEE,mBAAA;EACA,kBAAA;AAhJF;;AAkJA;;EAEE,mBAAA;EACA,kBAAA;AA/IF;;AAiJA;;EAEE,mBAAA;AA9IF;;AAgJA;;EAEE,mBAAA;AA7IF;;AAgJA,2CAAA;AACA;EACE,oCAAA;EACA,yBAAA;EACA,gDAAA;AA7IF;;AA+IA;EACE,oCAAA;EACA,yBAAA;EACA,iDAAA;AA5IF;;AA8IA;EACE,oCAAA;EACA,yBAAA;EACA,iDAAA;AA3IF","sourcesContent":["/* Access Requests Component - Using Standard Flowchest Dashboard Styles */\n\n/* Status badge styling */\n.status-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-approved {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-rejected {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n/* Flowchest button styling */\n.btn {\n  font-family: \"Raleway\" !important;\n  font-weight: 500 !important;\n  border-radius: 5px !important;\n  transition: all 0.3s ease !important;\n  cursor: pointer !important;\n  text-transform: none !important;\n}\n\n.btn-primary {\n  background-color: #5ea1d8 !important;\n  color: #fff !important;\n  border: none !important;\n  padding: 8px 16px !important;\n  font-size: 14px !important;\n}\n\n.btn-primary:hover {\n  background-color: #4a8bc4 !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;\n}\n\n.btn-warn {\n  background-color: #f44336 !important;\n  color: #fff !important;\n  border: none !important;\n  padding: 8px 16px !important;\n  font-size: 14px !important;\n}\n\n.btn-warn:hover {\n  background-color: #d32f2f !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 8px rgba(244, 67, 54, 0.3) !important;\n}\n\n.btn:disabled {\n  opacity: 0.6 !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Custom select styling to match Flowchest design */\n.status-filter {\n  background: transparent;\n  border: none;\n  color: #5ea1d8;\n  font-family: \"Raleway\";\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n/* Ensure consistent Flowchest typography */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nspan,\ndiv,\ntd,\nth {\n  font-family: \"Raleway\", Arial, Helvetica, sans-serif !important;\n}\n\n/* Table styling to match Flowchest design */\n.responsive-tabel {\n  font-family: \"Raleway\", Arial, Helvetica, sans-serif !important;\n\n  th,\n  td {\n    font-family: \"Raleway\", Arial, Helvetica, sans-serif !important;\n    font-size: 14px !important;\n  }\n\n  th {\n    font-weight: 600 !important;\n    color: #333 !important;\n    background-color: #f5f5f5 !important;\n    text-transform: uppercase !important;\n    font-size: 12px !important;\n    letter-spacing: 0.5px !important;\n    padding: 16px !important;\n    border-bottom: 2px solid #e0e0e0 !important;\n  }\n\n  td {\n    font-weight: 400 !important;\n    color: #666 !important;\n  }\n}\n\n/* Mobile tile styling to match Flowchest design */\n.mobile-design .tile {\n  font-family: \"Raleway\", Arial, Helvetica, sans-serif !important;\n\n  h3,\n  p,\n  span {\n    font-family: \"Raleway\", Arial, Helvetica, sans-serif !important;\n  }\n\n  .bold {\n    font-weight: 600 !important;\n  }\n}\n\n/* Ensure proper spacing for mobile view */\n@media (max-width: 768px) {\n  .mobile-design {\n    display: block;\n  }\n\n  .table-parent {\n    display: none;\n  }\n}\n\n@media (min-width: 769px) {\n  .mobile-design {\n    display: none;\n  }\n\n  .table-parent {\n    display: block;\n  }\n}\n\n/* Box grid layout (desktop) */\n.request-box-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n  margin: 16px 0;\n}\n@media (max-width: 992px) {\n  .request-box-grid {\n    display: none;\n  }\n}\n\n/* Make followers-tag cards look exactly like dashboard cards */\n.com-record {\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 0;\n  padding: 20px 30px 30px;\n  border: none !important;\n  .followers-tag {\n    .box {\n      .text {\n        p.number {\n          font-family: Arial !important;\n        }\n      }\n    }\n  }\n}\n\n.com-record:after {\n  content: \"\";\n  width: 100%;\n  height: 60%;\n  top: 0px;\n  position: absolute;\n  left: 0px;\n  z-index: 0;\n}\n\n.followers-tag {\n  display: flex;\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: none !important;\n  background-color: #fff !important;\n}\n\n.followers-tag .box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  // min-width: 200px;\n  gap: 12px;\n}\n\n.followers-tag .box .icon {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ico-box {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.text {\n  padding-right: 10px;\n}\n\n.followers-tag .box .ico-box {\n  width: 40px;\n  height: 40px;\n  background: transparent; /* remove bg */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0;\n}\n\n.followers-tag .box .card-icon {\n  font-size: 20px;\n  color: #5ea1d8;\n}\n\n.followers-tag .box .text {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  flex: 1;\n  justify-content: center;\n  gap: 2px;\n}\n\n.followers-tag .box .text .count {\n  background: white !important;\n  box-shadow: none !important;\n  display: flex;\n  align-items: center;\n}\n\n.followers-tag .box .text .count b {\n  font-size: 24px; /* increased to match dashboard */\n  font-weight: 700 !important; /* bold like dashboard */\n  color: #333;\n  display: block;\n  line-height: 1.2;\n}\n\n.followers-tag .box .text p {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n  line-height: 1.2;\n  display: block;\n}\n\n/* Responsive: match dashboard behavior */\n@media (max-width: 767px) {\n  .followers-tag {\n    gap: 12px;\n  }\n  .followers-tag .box {\n    width: 100%;\n    margin: 6px 0;\n    min-width: auto;\n    border-radius: 8px;\n  }\n  .followers-tag .box .ico-box {\n    width: 36px;\n    height: 36px;\n  }\n  .followers-tag .box .text .count b {\n    font-size: 20px !important;\n  }\n  .followers-tag .box .text p {\n    font-size: 13px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .followers-tag .box {\n    flex: 1 1 calc(50% - 12px);\n    min-width: calc(50% - 12px);\n  }\n}\n/* Mobile tile title icon */\n.mobile-design .tile .main-title {\n  display: flex;\n  align-items: center;\n}\n.mobile-design .tile .main-title .title-icon {\n  font-size: 18px;\n  margin-right: 6px;\n  color: #fff;\n}\n.btn-primary {\n  background-color: #5ea1d8;\n  border: none;\n}\n/* styles.css */\ntable {\n  border-collapse: collapse;\n  width: 100%;\n}\n\nth,\ntd {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\nth {\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  padding: 16px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\ntd {\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n  vertical-align: middle;\n}\n\ntr:hover {\n  background-color: #f9f9f9;\n}\n\n.generate-btn {\n  padding: 10px 20px 10px 10px;\n  text-align: right;\n}\n.table-parent {\n  overflow-x: auto;\n}\nbody {\n  overflow-x: hidden;\n}\n\n.dashbored-wrap {\n  width: 100%;\n  height: 100vh;\n  background: var(--fc-bg, #fff);\n  .logo {\n    width: 100px;\n    margin-right: 100px;\n  }\n  .top-menu-wrap {\n    display: flex;\n    align-items: center;\n    padding: 20px 10px;\n  }\n  .user-name {\n    display: flex;\n    align-items: center;\n  }\n  .user-details {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n  }\n  .user-name p {\n    display: flex;\n    align-items: center;\n  }\n  .user-name span {\n    width: 40px;\n    height: 40px;\n    background: red;\n    border-radius: 50%;\n    display: block;\n    margin-right: 10px;\n  }\n\n  .top-menu-wrap {\n    width: 100%;\n    height: 100px;\n\n    background: #fff;\n  }\n  .dash-details {\n    width: 100%;\n    display: flex;\n    max-height: 100vh;\n\n    /* background: green; */\n  }\n  .detail-list {\n    max-width: 250px;\n    width: 100%;\n    padding: 20px 10px;\n    background-color: #efeeee;\n    color: #212529;\n    position: fixed;\n    top: calc(var(--app-header) + 24px);\n    height: calc(100vh - 120px);\n  }\n  ul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n  }\n  p {\n    margin-bottom: 10px;\n  }\n  // .scroll-div {\n  //   position: absolute;\n  //   top: 120px !important;\n  //   width: 100%;\n  // }\n\n  ul li {\n    margin-bottom: 10px;\n    height: 40px;\n\n    padding: 0px 10px;\n    position: relative;\n    z-index: 1;\n    color: #212529;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  }\n  ul li:before {\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: 0px;\n    position: absolute;\n    background: #fff;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n    width: 0%;\n    z-index: -1;\n  }\n  ul li:hover {\n    color: #000;\n  }\n  ul li:hover:before {\n    /* background: #fff;\n    color: #212529; */\n    width: 100%;\n  }\n  .table-bordered {\n    border: 0px;\n  }\n  .detail-description {\n    width: 100%;\n    height: 100%;\n    padding: 0px;\n    // width: calc(100% - 250px);\n    position: absolute;\n    // left: 250px;\n    // top: 120px;\n    /* background: purple; */\n  }\n\n  .followers-tag {\n    display: flex;\n    position: relative;\n    z-index: 1;\n  }\n  h3 {\n    position: relative;\n    z-index: 3;\n    color: #fff;\n    font-weight: normal;\n  }\n  .com-record {\n    width: calc(100% - 250px);\n    width: 100%;\n    height: auto;\n    position: relative;\n    z-index: 0;\n    padding: 20px 30px 30px;\n    // position: fixed;\n    // top:80px;\n    // left:250px;\n    // background: white;\n    // z-index: 100;\n    .followers-tag {\n      .box {\n        .text {\n          p.number {\n            font-family: Arial !important;\n          }\n        }\n      }\n    }\n  }\n  .com-record:after {\n    content: \"\";\n    width: 100%;\n    height: 60%;\n    /* background: gray; */\n    top: 0px;\n    position: absolute;\n    left: 0px;\n    z-index: 0;\n    background: #5ea1d8;\n  }\n  .ico-box {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .table-wrap {\n    padding: 30px 30px 30px 0px;\n    position: absolute;\n    top: 150px;\n    width: calc(100% - 30px);\n    width: 100%;\n    left: 0px;\n    /* width:calc(100% - 76px); */\n  }\n  .box {\n    width: auto;\n    padding: 5px 10px;\n    background: #fff;\n    margin-right: 20px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: row;\n    box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  }\n  .filter-ico li {\n    width: 105px;\n  }\n  .filter-ico li i {\n    color: #000;\n  }\n  .text {\n    padding-right: 10px;\n  }\n  .table-parent {\n    overflow-x: auto;\n    margin-top: -8px;\n    // max-height: 400px;\n    overflow-y: auto;\n  }\n  table {\n    margin-bottom: 20px;\n    // border-collapse:separate;\n    // border-spacing:0 0.5em;\n    border-left: 0px;\n    border-bottom: 0px;\n    border: 0px;\n    // max-height: 600px;\n    overflow-y: auto;\n    width: 100%;\n  }\n  th,\n  td {\n    border: none;\n    color: #333;\n    padding: 16px;\n    min-width: 100px;\n    font-family: \"Raleway\";\n    vertical-align: middle;\n  }\n  th {\n    background-color: #f5f5f5;\n    font-weight: 600;\n    color: #333;\n    text-transform: uppercase;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    padding: 16px;\n    border-bottom: 2px solid #e0e0e0;\n  }\n  td {\n    padding: 16px;\n    border-bottom: 1px solid #e0e0e0;\n    vertical-align: middle;\n  }\n  td[scope=\"row\"] {\n    position: relative;\n  }\n  .inner {\n    width: 100%;\n    margin-bottom: 0px;\n    td {\n      padding: 5px;\n      border: 0px;\n      &:first-child {\n        width: 30px;\n      }\n    }\n  }\n  tbody tr {\n    cursor: pointer;\n    transition: background-color 0.2s;\n    &:first-child {\n      // display: flex;\n    }\n    &:hover {\n      background-color: #f9f9f9;\n      td {\n        color: #333;\n      }\n    }\n    &:last-child td {\n      border-bottom: none;\n    }\n    span {\n      display: flex;\n      align-items: center;\n    }\n  }\n  // tr:nth-child(even){\n  //     background: #5ea1d8;\n\n  // }\n  // tr:nth-child(even) td{\n  //     color: #fff;\n  // }\n\n  .filter {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n    border: none;\n    padding: 0 0 16px;\n    // position: fixed;\n    // width:calc(100% - 250px);\n  }\n  .filter-title {\n    flex: 1;\n  }\n  .filter ul {\n    display: flex;\n    float: right;\n  }\n  .filter-bar {\n    display: flex;\n    width: 100%;\n    gap: 16px;\n    align-items: center;\n  }\n  .filter-bar .input {\n    flex: 0 0 auto;\n  }\n  .filter-ico {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n  }\n  .search-container {\n    position: relative;\n    width: 400px;\n    max-width: 100%;\n\n    ::ng-deep .mat-mdc-form-field {\n      width: 100%;\n    }\n  }\n\n  .chekbox-image {\n    display: flex;\n    td {\n      &:first-child {\n        width: unset;\n        flex: 1;\n        min-width: 150px;\n        display: flex;\n        align-items: flex-start;\n        span {\n          padding-left: 13px;\n        }\n      }\n      &:last-child {\n        min-width: unset;\n        width: 40px;\n        display: flex;\n        align-items: flex-start;\n      }\n    }\n  }\n  .image-sec {\n    img {\n      max-width: 100%;\n      max-height: 80px;\n      // width: 100%;\n      object-fit: cover;\n    }\n  }\n  .bundel {\n    span {\n      img {\n      }\n    }\n  }\n  .mobile-design {\n    display: none;\n  }\n}\n\n/* Flow Reviews–style filters/search bar */\n.filters-section {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: nowrap;\n  align-items: center;\n  overflow: visible;\n\n  .search-filter {\n    flex: 1 1 640px;\n    min-width: 320px;\n    max-width: 720px;\n\n    .search-field {\n      width: 100%;\n\n      ::ng-deep .mat-mdc-form-field {\n        width: 100%;\n      }\n\n      ::ng-deep .mat-mdc-text-field-wrapper {\n        width: 100%;\n      }\n\n      ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n        display: none;\n      }\n\n      ::ng-deep .mat-mdc-form-field-infix {\n        min-height: 40px;\n        padding-top: 8px;\n        padding-bottom: 8px;\n      }\n\n      ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {\n        top: 20px;\n      }\n\n      ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {\n        --mat-mdc-form-field-label-transform: translateY(-26.75px) scale(var(--mat-mdc-form-field-floating-label-scale, 0.75));\n        transform: var(--mat-mdc-form-field-label-transform);\n      }\n    }\n  }\n\n  .flow-filter {\n    display: flex;\n    align-items: center;\n    min-width: 200px;\n    max-width: 240px;\n    overflow: visible;\n\n    .status-filter {\n      width: 100%;\n      height: 40px;\n      box-sizing: border-box;\n      padding: 0 12px;\n      border-radius: 4px;\n      border: 1px solid #ddd;\n      background-color: #fff;\n      font-size: 14px;\n    }\n  }\n}\n\n/* Access Requests dialog sizing/alignment overrides */\n::ng-deep .access-requests-dialog .confirmation-dialog {\n  max-width: 560px;\n}\n\n/* Reduce overall height and inner paddings */\n::ng-deep .access-requests-dialog .confirmation-content {\n  padding: 12px 16px !important;\n  max-height: 62vh; /* reduce content height */\n}\n\n/* Tighten comment form spacing */\n::ng-deep .access-requests-dialog .comment-form-section {\n  margin: 12px 16px !important;\n  padding: 12px !important;\n}\n\n/* Compact header */\n::ng-deep .access-requests-dialog .dialog-header {\n  padding: 12px 16px 8px !important;\n}\n\n/* Sticky actions with correct alignment and spacing */\n::ng-deep .access-requests-dialog mat-dialog-actions.mat-dialog-actions {\n  padding: 10px 16px !important;\n  gap: 8px !important;\n  justify-content: flex-end !important;\n  align-items: center !important;\n}\n\n/* Normalize buttons: same height and min-width */\n::ng-deep .access-requests-dialog mat-dialog-actions .mat-mdc-button-base {\n  height: 36px !important;\n  min-width: 110px !important;\n  padding: 0 14px !important;\n}\n\n/* Ensure cancel has border and sits inline neatly */\n::ng-deep .access-requests-dialog button.mat-button.cancel-btn {\n  border: 1px solid #ddd !important;\n}\n\n@media (max-width: 600px) {\n  ::ng-deep .access-requests-dialog .confirmation-dialog {\n    max-width: calc(100vw - 24px);\n  }\n  ::ng-deep .access-requests-dialog .confirmation-content {\n    max-height: calc(100vh - 160px);\n  }\n  ::ng-deep .access-requests-dialog mat-dialog-actions.mat-dialog-actions {\n    flex-direction: column;\n    align-items: stretch !important;\n  }\n  ::ng-deep .access-requests-dialog mat-dialog-actions .mat-mdc-button-base {\n    width: 100% !important;\n  }\n}\n@media (max-width: 992px) {\n  .dashbored-wrap {\n    .detail-list {\n      display: none;\n    }\n    .detail-description {\n      width: 100%;\n      left: 0px;\n    }\n    .followers-tag {\n      flex-wrap: wrap;\n      .box {\n        margin: 0px;\n        width: 100%;\n        .text {\n          flex: 1;\n        }\n      }\n    }\n    .com-record {\n      padding: 15px;\n      // margin-top: 20px;\n      &:after {\n        height: 130px;\n      }\n    }\n    .filter {\n      // display: none;\n    }\n    .search-container {\n      .search-input {\n        display: none;\n      }\n    }\n    .top-menu-wrap {\n      display: none;\n    }\n    .table-wrap {\n      top: unset;\n      /* keep default hidden tables, but allow inside mobile section */\n      .table-parent {\n        display: none;\n      }\n    }\n    .mobile-design {\n      padding: 20px 10px;\n      background: #f8f9fa;\n      display: block;\n      /* Hide search bar on mobile */\n      .filter {\n        .input,\n        .search-container {\n          display: none !important;\n        }\n      }\n      /* Re-enable table UI within the mobile-design wrapper */\n      .table-parent {\n        display: block !important;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n      }\n      .table-card {\n        display: block !important;\n      }\n      table {\n        display: table !important;\n        width: 100%;\n      }\n      .tile {\n        background: #fff;\n        padding: 15px;\n        margin-bottom: 15px;\n        border-radius: 8px;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n        border: 1px solid #e9ecef;\n        & > div {\n          border-bottom: 1px solid #e9ecef;\n          padding: 8px 0;\n          &:last-child {\n            border-bottom: none;\n          }\n        }\n        p {\n          color: #5ea1d8 !important;\n          margin: 2px 0;\n        }\n        p.bold {\n          font-weight: 600 !important;\n          font-family: \"Raleway\", Arial, Helvetica, sans-serif !important;\n          color: #333 !important;\n        }\n        .main-title {\n          display: flex;\n          align-items: center;\n          background: #5ea1d8;\n          padding: 12px 15px;\n          margin: -15px -15px 15px -15px;\n          border-radius: 8px 8px 0 0;\n          h3 {\n            margin-bottom: 0px !important;\n            color: #fff !important;\n            font-family: \"Raleway\", Arial, Helvetica, sans-serif !important;\n            font-weight: 500 !important;\n          }\n        }\n      }\n      .first-tile {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        margin-bottom: 10px;\n\n        div {\n          display: flex;\n          align-items: center;\n          flex: 1;\n          span {\n            display: flex;\n            align-items: center;\n            margin-left: 10px;\n          }\n        }\n\n        input {\n          position: relative;\n          margin: 0px 10px 0px 0px;\n          width: 20px;\n          height: 20px;\n        }\n\n        .img {\n          display: flex;\n          align-items: flex-start;\n          margin-left: 15px;\n          .bundle {\n            width: 30px;\n            margin-right: 10px;\n            height: 30px;\n          }\n          img {\n            width: 80px;\n            height: 60px;\n            object-fit: cover;\n            border-radius: 4px;\n            border: 1px solid #e9ecef;\n          }\n        }\n      }\n      .common-tile {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 10px;\n        .title-tile {\n          flex: 1;\n          min-width: 120px;\n          padding: 8px 0;\n          p:first-child {\n            font-size: 12px;\n            color: #6c757d !important;\n            margin-bottom: 4px;\n            text-transform: none;\n            letter-spacing: normal;\n          }\n          p.bold {\n            font-size: 14px;\n            line-height: 1.4;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* new setting common design starts here*/\n\n.setting-dashboard {\n  padding: 0;\n  height: auto;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n  .left-user {\n    background: #5ea1d8;\n    position: relative;\n    padding: 0 0 0 30px;\n    position: fixed;\n    top: 120px;\n    height: calc(100vh - 100px);\n    z-index: 3;\n    .collapse-btn {\n      position: absolute;\n      width: 25px;\n      height: 25px;\n      background: #5ea1d8;\n      border-radius: 50%;\n      right: -12.5px;\n      top: 26px;\n      border: 2px solid #fff;\n      box-shadow: 0 0 3px #171717;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #fff;\n      transform: rotate(180deg);\n    }\n    .dash-elemenet {\n      height: calc(100vh - 180px);\n      ul {\n        padding: 0px;\n        margin: 0px;\n        width: 100%;\n        list-style-type: none;\n        li {\n          height: 40px;\n          margin-bottom: 10px;\n          position: relative;\n          display: flex;\n          align-items: center;\n          transition: all 0.5s linear;\n          padding-left: 10px;\n          &:after {\n            bottom: 0;\n            content: \"\";\n            display: block;\n            height: 1px;\n            height: 100%;\n            left: 0%;\n            position: absolute;\n            background: #fff;\n            background: #1d67a3;\n            transition: all 0.5s linear;\n            width: 0;\n            z-index: -1;\n          }\n          &:hover:after,\n          &:active:after,\n          &:focus:after {\n            content: \"\";\n            width: 100%;\n            left: 0;\n            transition: all 0.5s linear;\n          }\n        }\n      }\n    }\n  }\n}\n.dashbored-wrap {\n  padding-left: 0px;\n  margin-top: 0;\n}\n\n.setting-dashboard .left-user .dash-title {\n  position: unset;\n  width: 100%;\n}\n.setting-dashboard .dash-title {\n  height: 80px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: #fff;\n  position: fixed;\n  z-index: 2;\n  top: calc(var(--app-header) + 24px);\n}\n.setting-dashboard .dash-title h6,\n.setting-dashboard .dash-title .h6 {\n  display: flex;\n  align-items: center;\n  font-weight: 500 !important;\n  color: #fff !important;\n}\n.setting-dashboard .dash-title h6 span,\n.setting-dashboard .dash-title .h6 span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.setting-dashboard .dash-elemenet {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-top: 1rem;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 20px;\n}\n.setting-dashboard .dash-elemenet > div {\n  width: 100%;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.5slinear;\n  position: relative;\n  padding-bottom: 0;\n  z-index: 2;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n.left-user .selected-item {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n.setting-dashboard .left-user .dash-elemenet > div span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n/*right section*/\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  // border-left: 1px solid #fff;\n  color: #fff;\n  // left: 16.666667%;\n  width: 83.333333%;\n}\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important; /* match landing page */\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n  .dash-text {\n    padding: 10px 15px 0; /* match landing page padding */\n  }\n}\n\n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n\n.setting-dashboard .dash-elemenet > div:after {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 1px;\n  height: 100%;\n  left: 0%;\n  position: absolute;\n  background: #fff;\n  background: #6322b2;\n  transition: width 0.5sease 0s, left 0.5sease 0s;\n  width: 0;\n  z-index: -1;\n}\n.setting-dashboard .dash-elemenet > div span:last-child {\n  font-size: 12px !important;\n}\n\n@media (max-width: 767px) {\n  .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n  \n  .mob-menu {\n    background: #5d9fd5 !important;\n    position: sticky;\n    top: var(--app-header, 56px);\n    z-index: 1500;\n    width: 100%;\n    display: block !important;\n  }\n  .navbar {\n    justify-content: flex-start;\n    margin-bottom: 0px;\n  }\n  .mob-menu button {\n    background: #5d9fd5 !important;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 14px;\n    padding: 10px 5px;\n    text-transform: capitalize;\n    border: 1px solid #fff !important;\n    box-shadow: none !important;\n    display: flex !important;\n    align-items: center;\n  }\n  .setting-dashboard .left-user {\n    width: 59vw;\n    position: fixed;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: calc(100vh - (var(--app-header, 56px) + 48px));\n    padding-left: 10px;\n    left: -59vw;\n    transition: left 0.5s linear;\n    display: block !important;\n    z-index: 1600;\n  }\n  .setting-dashboard .show-menu .left-user {\n    left: 0px;\n    transition: left 0.5s linear;\n  }\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0px;\n  }\n  .dashbored-wrap .table-wrap {\n    padding: 0px;\n  }\n  .setting-dashboard .submission-field .hamburger .dash-title {\n    width: 100%;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: 40px;\n  }\n  .setting-dashboard .left-user .dash-title {\n    display: none;\n  }\n  .setting-dashboard .left-user .collapse-btn {\n    display: none;\n  }\n  .dashbored-wrap {\n    margin-top: 10px !important;\n  }\n  .dashbored-wrap .mobile-design {\n    padding: 20px;\n  }\n  .dashbored-wrap .com-record:after {\n    height: 133px;\n  }\n\n  /* Search and filter bar: full width on mobile */\n  .filter,\n  .filters-section {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n  }\n  .filters-section {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding: 0 20px;\n  }\n  .filters-section .search-filter {\n    flex: 1 1 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .filters-section .search-field,\n  .filters-section .search-field ::ng-deep .mat-mdc-form-field,\n  .filters-section .search-field ::ng-deep .mat-mdc-text-field-wrapper {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n  .filters-section .flow-filter {\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .filters-section .flow-filter mat-form-field,\n  .filters-section .flow-filter .status-filter,\n  .filters-section .flow-filter ::ng-deep .mat-mdc-form-field {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n// Skeleton Loader Styles\n.skeleton-stats-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.skeleton-box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  min-width: 150px;\n  flex: 1;\n}\n\n.skeleton-table-container {\n  margin: 16px 0;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  width: 100%;\n  min-height: 300px;\n  overflow-x: auto;\n}\n\n.skeleton-mobile-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin: 16px 0;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  width: 100%;\n  min-height: 400px;\n}\n\n// Skeleton element styles\n.skeleton-text {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  height: 16px;\n  margin: 4px 0;\n\n  &.skeleton-title {\n    height: 20px;\n    width: 80%;\n  }\n\n  &.skeleton-bold {\n    height: 18px;\n    width: 60%;\n  }\n}\n\n.skeleton-checkbox {\n  width: 20px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 3px;\n  margin-right: 10px;\n}\n\n.skeleton-icon {\n  width: 20px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 50%;\n}\n\n.skeleton-image {\n  width: 100%;\n  height: 80px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.skeleton-price {\n  width: 60px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-left: 10px;\n}\n\n.skeleton-analytics {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.skeleton-tile {\n  background: #fff;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  width: 100%;\n\n  .main-title {\n    display: flex;\n    align-items: center;\n    background: #5ea1d8;\n    padding: 10px;\n    margin-bottom: 10px;\n\n    .skeleton-title {\n      height: 24px;\n      width: 70%;\n    }\n  }\n\n  .first-tile {\n    div {\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n    }\n\n    .img {\n      display: flex;\n      align-items: flex-start;\n\n      .bundle {\n        width: 30px;\n        margin-right: 10px;\n        height: 30px;\n      }\n    }\n  }\n\n  .common-tile {\n    display: flex;\n\n    .title-tile {\n      flex: 1;\n      padding: 3px;\n    }\n  }\n}\n\n// Skeleton loading animation\n@keyframes skeleton-loading {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n// Mobile responsiveness for skeleton containers\n@media (max-width: 768px) {\n  .skeleton-stats-container {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    padding: 12px;\n    width: 100%;\n    min-height: 150px;\n  }\n\n  .skeleton-table-container {\n    padding: 12px;\n    margin: 12px 0;\n    width: 100%;\n    min-height: 250px;\n    display: block;\n  }\n\n  .skeleton-mobile-container {\n    padding: 12px;\n    margin: 12px 0;\n    width: 100%;\n    min-height: 300px;\n    display: flex;\n  }\n}\n\n@media (max-width: 480px) {\n  .skeleton-stats-container {\n    padding: 8px;\n    gap: 8px;\n    min-height: 120px;\n  }\n\n  .skeleton-table-container,\n  .skeleton-mobile-container {\n    padding: 8px;\n    margin: 8px 0;\n  }\n\n  .skeleton-table-container {\n    min-height: 200px;\n  }\n\n  .skeleton-mobile-container {\n    min-height: 250px;\n  }\n}\n\n// View Toggle Styles (match Flow Reviews circular icon)\n.filter {\n  .view-toggle {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n\n    button {\n      color: #5ea1d8;\n      border: none !important;\n      box-shadow: none !important;\n      background: transparent !important;\n      padding: 0 !important;\n      width: 40px !important;\n      height: 40px !important;\n      min-width: 40px !important;\n      min-height: 40px !important;\n      border-radius: 50% !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n\n      &:hover {\n        background-color: rgba(94, 161, 216, 0.1) !important;\n      }\n\n      &:focus {\n        outline: none !important;\n        background-color: rgba(94, 161, 216, 0.18) !important;\n      }\n\n      mat-icon {\n        font-size: 22px !important;\n        width: 22px !important;\n        height: 22px !important;\n        line-height: 22px !important;\n      }\n    }\n  }\n}\n\n// Card View Styles\n.access-requests-list-card {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-top: 20px;\n\n  .loading-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 20px;\n\n    p {\n      margin-top: 16px;\n      color: #666;\n    }\n  }\n\n  .no-requests {\n    text-align: center;\n    padding: 60px 20px;\n\n    mat-icon {\n      font-size: 64px;\n      width: 64px;\n      height: 64px;\n      color: #ccc;\n      margin-bottom: 16px;\n    }\n\n    h3 {\n      margin: 0 0 8px 0;\n      color: #666;\n    }\n\n    p {\n      margin: 0;\n      color: #999;\n    }\n  }\n\n  .request-card-modern {\n    background-color: #fff;\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n    overflow: hidden;\n    transition: all 0.3s ease;\n    box-sizing: border-box;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);\n    }\n\n    .card-content {\n      padding: 24px;\n    }\n\n    .request-header-modern {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n      margin-bottom: 24px;\n\n      @media (min-width: 640px) {\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: flex-start;\n      }\n\n      .requester-info-modern {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n\n        .requester-avatar-modern {\n          width: 48px;\n          height: 48px;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: white;\n          font-weight: 700;\n          font-size: 16px;\n          background-color: #5ea1d8;\n          flex-shrink: 0;\n        }\n\n        .requester-details-modern {\n          display: flex;\n          flex-direction: column;\n\n          .requester-name-modern {\n            margin: 0;\n            font-weight: 700;\n            font-size: 16px;\n            color: #0f172a;\n          }\n\n          .requester-email-modern {\n            margin: 4px 0 0 0;\n            font-size: 12px;\n            color: #94a3b8;\n          }\n\n          .requester-username-modern {\n            margin: 2px 0 0 0;\n            font-size: 12px;\n            color: #64748b;\n          }\n        }\n      }\n\n      .status-badge-modern {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        padding: 6px 12px;\n        border-radius: 9999px;\n        font-size: 12px;\n        font-weight: 600;\n        text-transform: uppercase;\n\n        &.status-pending {\n          background-color: #fef3c7;\n          color: #d97706 !important;\n        }\n\n        &.status-approved {\n          background-color: #dcfce7;\n          color: #16a34a !important;\n        }\n\n        &.status-rejected {\n          background-color: #fee2e2;\n          color: #dc2626 !important;\n        }\n      }\n    }\n\n    .request-content-modern {\n      margin-bottom: 24px;\n\n      .request-field {\n        margin-bottom: 16px;\n\n        label {\n          display: block;\n          font-size: 12px;\n          font-weight: 600;\n          text-transform: uppercase;\n          letter-spacing: 0.1em;\n          color: #94a3b8;\n          margin-bottom: 8px;\n        }\n\n        p {\n          margin: 0 0 12px 0;\n          color: #334155;\n          line-height: 1.6;\n          font-size: 15px;\n\n          &.flow-link-modern {\n            color: #5ea1d8;\n            cursor: pointer;\n            font-weight: 500;\n\n            &:hover {\n              text-decoration: underline;\n            }\n          }\n        }\n\n        .response-message {\n          background-color: #f8fafc;\n          border-left: 3px solid #5ea1d8;\n          padding: 12px;\n          border-radius: 4px;\n          margin-top: 8px;\n\n          p {\n            margin: 0 0 8px 0;\n            color: #334155;\n          }\n\n          .response-date {\n            font-size: 12px;\n            color: #94a3b8;\n          }\n        }\n      }\n\n      .request-details-grid {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 16px;\n\n        @media (min-width: 640px) {\n          grid-template-columns: 1fr 1fr;\n        }\n\n        .detail-item {\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n\n          label {\n            font-size: 12px;\n            font-weight: 600;\n            text-transform: uppercase;\n            letter-spacing: 0.1em;\n            color: #94a3b8;\n          }\n\n          span {\n            font-size: 14px;\n            color: #334155;\n            font-weight: 500;\n          }\n        }\n      }\n    }\n\n    .request-actions-modern {\n      display: flex;\n      gap: 12px;\n      padding-top: 16px;\n      border-top: 1px solid #f1f5f9;\n\n      button {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .access-requests-list-card {\n    .request-card-modern {\n      border-radius: 12px;\n\n      .card-content {\n        padding: 16px;\n      }\n\n      .request-header-modern {\n        flex-direction: column;\n        gap: 12px;\n      }\n\n      .request-content-modern {\n        .request-details-grid {\n          grid-template-columns: 1fr;\n        }\n      }\n\n      .request-actions-modern {\n        flex-direction: column;\n      }\n    }\n  }\n}\n\n// ==============================================\n// DARK MODE\n// ==============================================\n:host-context(body.theme-dark) {\n  .dashbored-wrap,\n  .setting-dashboard,\n  .scroll-div,\n  .com-record,\n  .table-wrap,\n  .filter,\n  .filters-section,\n  .search-input,\n  .detail-list {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  // filter dropdown\n  .filters-section .status-filter {\n    background: #0f172a !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  table, thead, tbody, tr, td {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  th {\n    background: #0f172a !important;\n    background-color: #0f172a !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  tbody tr:hover { background: #1f2937 !important; }\n\n  .box {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    color: #e5e7eb !important;\n  }\n\n  p, span:not(.material-icons):not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]), label, li, h1, h2, h3, h4, h5, h6, i, b {\n    color: #e5e7eb !important;\n  }\n\n  .mobile-design {\n    background: #0f172a !important;\n    .tile {\n      background: #1f2937 !important;\n      border-color: rgba(148, 163, 184, 0.25) !important;\n    }\n  }\n\n  // Shimmer skeleton\n  .skeleton-text { background: linear-gradient(90deg, #1f2937 25%, #374151 37%, #1f2937 63%) !important; background-size: 400% 100% !important; }\n\n  // Access request cards\n  .access-requests-list-card .request-card-modern {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    .requester-name-modern { color: #f1f5f9 !important; }\n    .requester-email-modern,\n    .requester-username-modern { color: #94a3b8 !important; }\n    .request-field {\n      label { color: #64748b !important; }\n      p { color: #cbd5e1 !important; }\n    }\n    .response-message {\n      background: #0f172a !important;\n      p { color: #cbd5e1 !important; }\n      .response-date { color: #64748b !important; }\n    }\n    .detail-item {\n      label { color: #64748b !important; }\n      span { color: #f1f5f9 !important; }\n    }\n    .request-actions-modern { border-color: rgba(148, 163, 184, 0.2) !important; }\n  }\n}\n\n\n// ════════════════════════════════════════════════\n// DARK MODE – direct body.theme-dark rules\n// These compile to body.theme-dark .class[_ngcontent-xxx]\n// which reliably overrides all hardcoded whites.\n// ════════════════════════════════════════════════\nbody.theme-dark .dashbored-wrap,\nbody.theme-dark .setting-dashboard {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .top-menu-wrap,\nbody.theme-dark .dashbored-wrap .box,\nbody.theme-dark .dashbored-wrap .card,\nbody.theme-dark .dashbored-wrap .mat-mdc-card,\nbody.theme-dark .dashbored-wrap .tile,\nbody.theme-dark .dashbored-wrap .com-record,\nbody.theme-dark .dashbored-wrap .table-wrap,\nbody.theme-dark .dashbored-wrap .detail-list,\nbody.theme-dark .dashbored-wrap .filter,\nbody.theme-dark .dashbored-wrap .search-input,\nbody.theme-dark .dashbored-wrap .tab-content,\nbody.theme-dark .dashbored-wrap .followers-tag .box {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap table,\nbody.theme-dark .dashbored-wrap thead,\nbody.theme-dark .dashbored-wrap tbody,\nbody.theme-dark .dashbored-wrap tr,\nbody.theme-dark .dashbored-wrap td {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap th {\n  background: var(--fc-bg-head) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap tbody tr:hover {\n  background: var(--fc-bg-hover) !important;\n}\n\nbody.theme-dark .dashbored-wrap input,\nbody.theme-dark .dashbored-wrap select,\nbody.theme-dark .dashbored-wrap textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design .tile {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap [class*=\"skeleton-\"] {\n  background: var(--fc-skel) !important;\n  color: transparent !important;\n}\n\nbody.theme-dark .dashbored-wrap p,\nbody.theme-dark .dashbored-wrap label,\nbody.theme-dark .dashbored-wrap li,\nbody.theme-dark .dashbored-wrap h1,\nbody.theme-dark .dashbored-wrap h2,\nbody.theme-dark .dashbored-wrap h3,\nbody.theme-dark .dashbored-wrap h4,\nbody.theme-dark .dashbored-wrap h5,\nbody.theme-dark .dashbored-wrap h6 {\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=\"status\"]) {\n  color: var(--fc-fg) !important;\n}\n\n/* ── Direct body.theme-dark additions (access-requests page) ── */\n\nbody.theme-dark .access-requests-list-card .request-card-modern {\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .requester-name-modern {\n  color: #f1f5f9 !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .requester-email-modern,\nbody.theme-dark .access-requests-list-card .request-card-modern .requester-username-modern {\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .request-field label {\n  color: #64748b !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .request-field p {\n  color: #cbd5e1 !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .response-message {\n  background: #0f172a !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .response-message p {\n  color: #cbd5e1 !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .response-message .response-date {\n  color: #64748b !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .detail-item label {\n  color: #64748b !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .detail-item span {\n  color: #f1f5f9 !important;\n}\n\nbody.theme-dark .access-requests-list-card .request-card-modern .request-actions-modern {\n  border-top-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .followers-tag .box .text .count {\n  background: transparent !important;\n}\n\nbody.theme-dark .followers-tag .box .text .count b { color: #f1f5f9 !important; }\nbody.theme-dark .followers-tag .box .text p { color: #94a3b8 !important; }\n\nbody.theme-dark .filters-section .status-filter {\n  background: #0f172a !important;\n  color: #e5e7eb !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\n\nbody.theme-dark .responsive-tabel th {\n  background-color: var(--fc-bg-head) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .responsive-tabel td {\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .skeleton-box {\n  background: var(--fc-bg2) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .skeleton-table-container,\nbody.theme-dark .skeleton-mobile-container {\n  background: var(--fc-bg2) !important;\n}\n\nbody.theme-dark .skeleton-tile {\n  background: var(--fc-bg2) !important;\n  border-color: var(--fc-border) !important;\n}\n/* ── Override global white-background globals (.fc-table, .big-box, .filter-section) ── */\nbody.theme-dark .big-box {\n  background: #111827 !important;\n  background-color: #111827 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .fc-table {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .fc-table thead th {\n  background-color: #0f172a !important;\n  background: #0f172a !important;\n  color: #94a3b8 !important;\n  border-bottom-color: rgba(148, 163, 184, 0.25) !important;\n  border-right-color: rgba(148, 163, 184, 0.15) !important;\n}\nbody.theme-dark .fc-table tbody td {\n  background-color: #1f2937 !important;\n  color: #e2e8f0 !important;\n  border-top-color: rgba(148, 163, 184, 0.15) !important;\n  border-right-color: rgba(148, 163, 184, 0.1) !important;\n}\nbody.theme-dark .fc-table tbody tr:nth-child(even) td {\n  background-color: #253347 !important;\n}\nbody.theme-dark .fc-table tbody tr:hover td {\n  background-color: #374151 !important;\n  color: #f1f5f9 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\nbody.theme-dark .filter-section {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .filter-section label {\n  color: #94a3b8 !important;\n}\nbody.theme-dark .filter-section select,\nbody.theme-dark .filter-section input {\n  background: #0f172a !important;\n  background-color: #0f172a !important;\n  color: #e2e8f0 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\n\n/* ── Stat card count white-bg fix (highest specificity override) ── */\nbody.theme-dark .com-record .followers-tag .box {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .com-record .followers-tag .box .text .count {\n  background: transparent !important;\n  background-color: transparent !important;\n}\nbody.theme-dark .com-record .followers-tag .box .text .count b {\n  color: #f1f5f9 !important;\n}\nbody.theme-dark .com-record .followers-tag .box .text p {\n  color: #94a3b8 !important;\n}\nbody.theme-dark .com-record .followers-tag .box .card-icon {\n  color: #5ea1d8 !important;\n}\n\n/* ── Dark scrollbars and overflow area fix ── */\nbody.theme-dark .table-parent {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar,\nbody.theme-dark .table-card::-webkit-scrollbar {\n  background: #111827;\n  width: 6px;\n  height: 6px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-track,\nbody.theme-dark .table-card::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-corner,\nbody.theme-dark .table-card::-webkit-scrollbar-corner {\n  background: #111827;\n}\n\n/* ── Status badge dark mode overrides ── */\nbody.theme-dark .status-badge-modern.status-pending {\n  background-color: #451a03 !important;\n  color: #fcd34d !important;\n  border-color: rgba(252, 211, 77, 0.3) !important;\n}\nbody.theme-dark .status-badge-modern.status-approved {\n  background-color: #052e16 !important;\n  color: #86efac !important;\n  border-color: rgba(134, 239, 172, 0.3) !important;\n}\nbody.theme-dark .status-badge-modern.status-rejected {\n  background-color: #450a0a !important;\n  color: #fca5a5 !important;\n  border-color: rgba(252, 165, 165, 0.3) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
